<template>
  <form @submit.prevent="submit" v-if="$store.getters.isSuper">
    <div class="p-mb-3 p-input-filled">
      <div class="p-field">
        <InputText
          placeholder="Permission Name"
          type="text"
          class="permission-name"
          v-model="formData.name"
          @blur="validation.formData.name.$touch()"
          :class="{ 'p-invalid': validation.formData.name.$error }"
        />
        <BaseValidationErrors
          :field="validation.formData.name"
          :rules="['required']"
        />
      </div>
    </div>
    <Button
      type="submit"
      class="submit"
      :disabled="disabled || validation.$invalid"
      :label="label"
    />
  </form>
</template>

<script>
import { ref, watchEffect } from 'vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import BaseValidationErrors from '@/components/BaseValidationErrors.vue'
import { roles } from '@/helpers/constants'

export default {
  components: { Button, InputText, BaseValidationErrors },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Save Permission'
    },
    permission: {
      type: Object,
      default: new Object()
    }
  },
  emits: ['submitted'],
  setup(props, { emit }) {
    const formData = ref({
      name: null,
      roles: ['Super']
    })

    const rules = {
      formData: {
        name: { required }
      }
    }

    const validation = useVuelidate(rules, { formData })

    watchEffect(() => {
      if (Object.keys(props.permission).length) {
        formData.value = props.project
      }
    })

    function submit() {
      validation.value.$touch()
      if (!validation.value.$invalid) emit('submitted', formData.value)
    }

    return { formData, roles, validation, submit }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/forms.scss';
</style>
